import { memo } from "react";
import { Projects } from "../../../model/info-about-bootcamp";
import { sanitizeImageUrl } from "../../../utils/sanity.utils";

interface Props {
  data: Projects;
}

export const ProjectBlock = memo<Props>(({ data }) => {
  return (
    <div className="max-w-[1440px] m-auto lg:pb-46 pt-24 lg:pt-15 pl-5 pr-5 lg:pl-20 lg:pr-20">
      <h2
        // eslint-disable-next-line
        dangerouslySetInnerHTML={{
          __html: data.title,
        }}
        className="text-center text-[32px] lg:text-[58px] leading-[1] text-white"
      />
      <div
        className="text-[16px] leading-[130%] lg:text-[20px] lg:leading-[124%] pb-20 m-auto max-w-[800px] pt-6 lg:pt-8 lg:pb-46 text-center text-night-base-base-400"
        // eslint-disable-next-line
        dangerouslySetInnerHTML={{
          __html: data.subtitle,
        }}
      />
      <div className="lg:grid grid-cols-3 gap-[10px]">
        {data.list.map((item) => (
          <div
            key={item._key}
            className="relative flex mb-24 lg:mb-0 flex-col rounded-[20px] border border-solid border-night-base-base-400 pr-8 pl-8 pt-8 lg:pt-30 pb-10 lg:pb-15 lg:pt-40 lg:pl-20 lg:pr-20"
          >
            <div className="grow">
              {item.image && (
                <img
                  width={70}
                  height={70}
                  className="lg:absolute top-[-30px] rounded-[15px] pb-10 lg:pb-0"
                  src={sanitizeImageUrl(item.image.asset._ref)}
                  alt="Logo of project"
                />
              )}
              <div
                // eslint-disable-next-line
                dangerouslySetInnerHTML={{
                  __html: item.title,
                }}
                className="text-[34px] leading-[43px] text-white"
              />
              {item.description && (
                <div
                  // eslint-disable-next-line
                  dangerouslySetInnerHTML={{
                    __html: item.description,
                  }}
                  className="pt-9 pb-25 text-[18px] leading-[23px] text-night-base-base-400"
                />
              )}
            </div>
            <div className="flex">
              {item.stack.map((item, index) => (
                <div
                  key={index}
                  className="mr-5 w-fit rounded-[30px] border border-solid border-night-base-base-400 pt-2 pb-2 pl-8 pr-8 text-[15px] leading-[14px] text-night-base-base-400"
                  // eslint-disable-next-line
                  dangerouslySetInnerHTML={{
                    __html: item.title,
                  }}
                />
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
});
